module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Card is a container for other components with an adjustable paddings. A Nessie Card should wrap other components.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Card padding=&quot;S&quot;&gt;\n    &lt;div&gt;Some other components go here....&lt;/div&gt;\n&lt;/Card&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Card/README.md
// module id = 335
// module chunks = 0